<template>
    <div class="buy-one-click">
        <h5 v-if="result.messages" class="def-title-5">{{ result.messages.buyOneClickTitle }}</h5>
        <form class="def-validation buy-one-click__form">
            <div class="def-input-wrapper">
                <input type="text" class="def-tel-mask def-input" required>
            </div>
            <button v-if="result.messages" class="def-button">{{ result.messages.buyOneClickButton }}</button>
        </form>
    </div>
</template>
<script>
    export default {
        name: 'buy-one-click',
        props: ['result'],
        // mounted() {
        //     console.log(this.result);
        // }
    }
</script>
<style lang="scss">
    .buy-one-click{
        &__form{
            display: flex;
            //.def-input-wrapper{
            //    max-width: 100%;
            //}
        }
        h5.def-title-5{
            margin-bottom: 16px;
            line-height: 110%;
            text-transform: uppercase;
            font-size: rem(14);
            @include point-lg{
                margin-bottom: 24px;
                font-size: rem(18);
            }

        }
        input.def-input{
            margin-bottom: 0;
            width: 100%;
            height: 48px;
        }
        button.def-button{
            background: #B8D9EC;
            font-size: rem(14);
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            height: 48px;
            padding: 0 24px;
            &:hover{
                color: var(--text-colour-secondary);
            }
        }
        .def-input-wrapper{
            width: 100%;
        }
    }
</style>